module.exports = __webpack_public_path__ + "images/picto-sect-fans.png?4c65e";